// services/WarehouseProductItemMovementService.ts
import axios from 'axios';
import { WarehouseProductItemMovement } from '../models/WarehouseProductItemMovement';

const API_URL = process.env.REACT_APP_SERVER_URL + "/warehouseproductitemmovement";

const WarehouseProductItemMovementService = {
    getAllMovements: async () => {
        const response = await axios.get(`${API_URL}/getAllMovements`);
        return response.data;
    },

    getAllMovementsBySupplierId: async (supplierId: string) => {
        const response = await axios.get(`${API_URL}/getAllMovementsBySupplierId/${supplierId}`);
        return response.data;
    },

    getAllMovementsByWarehouseId: async (warehouseId: number) => {
        const response = await axios.get(`${API_URL}/getAllMovementsByWarehouseId/${warehouseId}`);
        return response.data;
    },

    getMovementsByProductItemId: async (productItemId: number): Promise<WarehouseProductItemMovement[]> => {
        const response = await axios.get(`${API_URL}/product-item/${productItemId}`);
        return response.data;
    },

    getMovementById: async (id: number): Promise<WarehouseProductItemMovement> => {
        const response = await axios.get(`${API_URL}/getMovementById/${id}`);
        return response.data;
    },

    createMovement: async (movementData: Omit<WarehouseProductItemMovement, 'id' | 'created_time' | 'updated_time'>): Promise<WarehouseProductItemMovement> => {
        const response = await axios.post(`${API_URL}/add`, movementData);
        return response.data;
    },

    updateMovement: async (id: number, movementData: Omit<WarehouseProductItemMovement, 'id' | 'created_time' | 'updated_time'>): Promise<WarehouseProductItemMovement> => {
        const response = await axios.put(`${API_URL}/update/${id}`, movementData);
        return response.data;
    },

    deleteMovement: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`);
    }
};

export default WarehouseProductItemMovementService;
